import * as React from 'react';
import { Layout, DatePicker, Button, List } from 'antd';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { clearNavbarState, updateNavbarState } from '../../actions/navbar_actions';
import { generateBackLink } from '../../utils/HistoryUtils';
import DetailPageHeader from '../detail_page_header/DetailPageHeader';
import {
	approvalsRestCrudThunksForBuyer,
	approvalsRestCrudThunksForSupplier,
	getBuyerCompanyApprovalTiers,
} from '../../thunks/company_approval_thunks';
import { ROLE_TYPES } from '../../utils/DataConstants';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { getApprovalHierarchiesIndexLink } from '../../utils/ApprovalHierarchyUtils';

const queryString = require('qs');

const ListItem = List.Item;
const { Content } = Layout;
const { RangePicker } = DatePicker;

class ApprovalHierarchyDetailPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			lightboxIsOpen: false,
			currentIndex: 0,
			backLinkTo: getApprovalHierarchiesIndexLink(props.userType),
			backLinkText: 'Back to Approval Hierarchies',
		};
	}

	componentDidMount() {
		const { getApprovalHierarchy, match, updateNavbar, location, userType } = this.props;
		const id = match.params.id;
		const indexLink = getApprovalHierarchiesIndexLink(userType);
		getApprovalHierarchy(id).then((approvalHierarchy) => {
			let searchString = location.search;
			if (searchString[0] === '?') {
				searchString = searchString.slice(1);
			}
			const queryParams = queryString.parse(searchString);
			if (queryParams.backlinkParams) {
				const { tab, pathName, backLinkText, ...otherParams } = queryString.parse(
					queryParams.backlinkParams
				);
				let backPath = pathName || indexLink;
				let backText = backLinkText || 'Back to Approval Hierarchies';
				updateNavbar(backText, generateBackLink(backPath, location));
			} else {
				updateNavbar('Back to Approval Hierarchies', generateBackLink(indexLink, location));
			}
		});
	}
	componentWillUnmount(): void {
		this.props.clearNavbar();
	}

	handleTabChange = (key) => {
		const { history, match, userType } = this.props;
		const id = match.params.id;
		history.push(`/${userType}/approvalHierarchies/${id}/${key}`);
	};

	checkTabActive = (key) => {
		const { history } = this.props;
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	};

	handleDelete = () => {
		const { history, deleteAsset, asset, userType } = this.props;
		deleteAsset(asset).then(() => {
			history.push(`/${userType}/approvalHierarchies/`);
		});
	};

	render() {
		const { approvalHierarchy, approvalHierarchiesFetching, match, companyConfig, userType } =
			this.props;
		const id = match.params.id;
		const indexLink = getApprovalHierarchiesIndexLink(userType);
		let tabs = [];
		return (
			<DetailPageHeader
				exactPath={indexLink}
				redirectPath={indexLink}
				backLinkText={this.state.backLinkText || 'Back to Templates'}
				backLinkTo={this.state.backLinkTo}
				title={id === 'new' ? 'New Approval Hierarchy' : nullSafeGet('name', approvalHierarchy)}
				subtitle={<div style={{ display: 'flex', flexWrap: 'wrap' }}></div>}
				subtext={<div></div>}
				actions={[]}
				tabs={tabs}
				handleTabChange={this.handleTabChange}
				checkTabActive={this.checkTabActive}
				childRoutes={this.props.childRoutes}
				backgroundColor={nullSafeGet('config.theme.navblock', companyConfig)}
			/>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	approvalHierarchiesFetching: state.approval_hierarchies.fetching,
	approvalHierarchy: state.approval_hierarchies.detail,
	match: ownProps.match,
	history: ownProps.history,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getApprovalHierarchy: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? approvalsRestCrudThunksForSupplier.readOne(id)
				: approvalsRestCrudThunksForBuyer.readOne(id)
		),
	updateNavbar: (backlinkTitle, backlinkTo, navbarBackgroundColor) =>
		dispatch(updateNavbarState(backlinkTitle, backlinkTo, navbarBackgroundColor)),
	clearNavbar: () => dispatch(clearNavbarState()),
});

const ApprovalHierarchyDetailPageWR = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(ApprovalHierarchyDetailPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ApprovalHierarchyDetailPageWR);
